import ColumnGroup from "./ColumnGroup";
import { ColumnGroup as ColumnGroupType } from "./types";

type Props = {
  columns: ColumnGroupType[];
  onClick: (uploadId: number) => void;
};

const Overview = ({ onClick, columns = [] }: Props) => {
  return (
    <div className="mt-space200 flex w-full flex-col overflow-hidden">
      <div className="mx-space150 grid grid-cols-4 gap-x-space150 overflow-hidden">
        {columns.map((column) => {
          return (
            <ColumnGroup key={column.title} onClick={onClick} {...column} />
          );
        })}
      </div>
    </div>
  );
};

export default Overview;
